import { render, staticRenderFns } from "./CardsEmulator.vue?vue&type=template&id=5d961d30&scoped=true&"
import script from "./CardsEmulator.vue?vue&type=script&lang=js&"
export * from "./CardsEmulator.vue?vue&type=script&lang=js&"
import style0 from "./CardsEmulator.vue?vue&type=style&index=0&id=5d961d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d961d30",
  null
  
)

export default component.exports